export enum EResCode {
  Success = 100000,
  RoomNotExist = 4001,
  RoomNotOnline = 4002,
  RoomOrPasswordError = 4003,
  OpponentBusy = 4004,
  OpponentNoResponse = 4005,
  OpponentRejected = 4006,
}
